import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IResult } from 'app/shared/models/result.model';
import { IDtoPeriod } from 'app/shared/models/payroll/dto-period.model';
import { IDtoMovementRestrictionCalendar } from 'app/shared/models/payroll/dto-movement-restriction-calendar.model';
import { IDtoEmployeeUpdatePayroll } from 'app/shared/models/employee/dto-employee-update-payroll.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoPayroll } from 'app/shared/models/payroll/dto-payroll.model';
import { IDtoPayrollFilter } from 'app/shared/models/payroll/dto-payroll-filter.model';
import { IDtoPayrollDetail } from 'app/shared/models/payroll/dto-payroll-detail.model';
import { IDtoRetention } from 'app/shared/models/payroll/dto-retention.model';
import { SecurityService } from '../../shared/services/security.service';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';

@Injectable()
export class PayrollService {
  private payrollUrl = '';
  private requestUrl = '';
  private roles: any;
  constructor(private service: DataService, private configurationService: ConfigurationService, private securityService: SecurityService) {
    if (this.configurationService.isReady) {
      this.payrollUrl = this.configurationService.serverSettings.payrollUrl;
      this.requestUrl = this.configurationService.serverSettings.requestUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.payrollUrl = this.configurationService.serverSettings.payrollUrl;
        this.requestUrl = this.configurationService.serverSettings.requestUrl;
      });
    }
    let showRoles = this.securityService.getUserRolesStorage();
    if (showRoles == '' || showRoles == undefined) {

    } else {
      this.roles = showRoles.listRoles;
    }
  }
  public getStartDatePeriod(companyNum: string, payrollType: string, date: Date): Observable<IResult> {
    const url = `${this.payrollUrl}api/Periods/getStartDatePeriod?companyNum=${companyNum}&payrollType=${payrollType}&date=${date}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getActivePeriod(dto: IDtoPeriod): Observable<IResult> {
    const url = `${this.payrollUrl}api/Periods/getActivePeriod/`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public restrictionExistCalendar(dto: IDtoMovementRestrictionCalendar): Observable<IResult> {
    const url = `${this.requestUrl}api/MovementRestrictionCalendars/restrictionExistCalendar/`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public getIntegratedDailySalary(codeNomCompanyNum: string, codeNomEmployeeNum: string, codeNomPayroll: string): Observable<number> {
    const url = `${this.payrollUrl}api/Employees/getIntegratedDailySalary?codeNomCompanyNum=${codeNomCompanyNum}&codeNomEmployeeNum=${codeNomEmployeeNum}&codeNomPayroll=${codeNomPayroll}`;
    return this.service.get(url).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateEmployeePayroll(dto: IDtoEmployeeUpdatePayroll): Observable<IResult> {
    const url = `${this.payrollUrl}api/Employees/updateEmployee/`;
    return this.service.putWithId(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public getCatalogPeriodsByCompanyPayrollType(codeNomCompanyNum: string, codeNomPayroll: string, year: number): Observable<IDtoCatalog[]> {
    const url = `${this.payrollUrl}api/Periods/getCatalogPeriodsByCompanyPayrollType?companyNum=${codeNomCompanyNum}&payrollType=${codeNomPayroll}&year=${year}`;
    return this.service.get(url).pipe(map((response: any) => {
      return response;
    }));
  }
  /** Del lado rednovation*/
  public addPayroll(dto: IDtoPayroll): Observable<IResult> {
    dto.userId = this.roles[0].userId;
    const url = `${this.requestUrl}api/Payrolls/addPayroll`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public getPayrollsByFilter(dto: IDtoPayrollFilter): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/getPayrollsByFilter`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public getPayrollDetailsByPayrollId(payrollId: string, userId: number, profile: string, module: string, routeType: string): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/getPayrollDetailsByPayrollId?payrollId=${payrollId}&userId=${userId}&profile=${profile}&module=${module}&routeType=${routeType}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public updatePayrollDetails(list: IDtoPayrollDetail[]): Observable<IResult> {
    list[0].userId = this.roles[0].userId;
    const url = `${this.requestUrl}api/PayrollDetails/updatePayrollDetails`;
    return this.service.putWithId(url, list).pipe(map((response: any) => {
      return response;
    }));
  }
  async actualizarLista(listaCompleta: any[], tamanoBloque: number): Promise<{ exito: boolean, mensaje: string }[]> {
    const resultados: { exito: boolean, mensaje: string }[] = [];

    for (let i = 0; i < listaCompleta.length; i += tamanoBloque) {
      const bloque = listaCompleta.slice(i, i + tamanoBloque);

      try {
        await this.service.putWithId(`${this.requestUrl}api/PayrollDetails/updatePayrollDetails`, bloque).toPromise();
        resultados.push({ exito: true, mensaje: `Bloque ${i / tamanoBloque + 1} actualizado correctamente.` });
      } catch (error) {
        resultados.push({ exito: false, mensaje: `Error al actualizar bloque ${i / tamanoBloque + 1}: ${error.message}` });
      }
    }

    return resultados;
  }
  public removeRetentions(list: any[]): Observable<IResult> {
    const url = `${this.requestUrl}api/PayrollDetails/removeRetentions`;
    return this.service.putWithId(url, list).pipe(map((response: any) => {
      return response;
    }));
  }
  public getPayrollDetailsByPayrollIdAndSupervisorId(payrollId: number, supervisorId: number, userId: number, profile: string, module: string): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/getPayrollDetailsByPayrollIdAndSupervisorId?payrollId=${payrollId}&supervisorId=${supervisorId}&userId=${userId}&profile=${profile}&module=${module}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public sendPayrollNom(payrollId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/sendPayrollNom?payrollId=${payrollId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public validateEmployessPayroll(payrollId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/validateEmployessPayroll?payrollId=${payrollId}&userId=${this.roles[0].userId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getRetentionsByPayrollId(payrollId: number): Observable<IDtoRetention[]> {
    const url = `${this.requestUrl}api/PayrollDetails/getRetentionsByPayrollId?payrollId=${payrollId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public removeRetention(dto: IDtoRetention): Observable<IResult> {
    const url = `${this.requestUrl}api/PayrollDetails/removeRetention/`;
    return this.service.putWithId(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public sendPayrollToCustomer(payrollId: number, approverUserId: string): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/sendPayrollToCustomer?payrollId=${payrollId}&approverUserId=${approverUserId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getCatalogPayrolls(companyPayId: number, payrollTypeId: number, profile: string): Observable<IDtoCatalog[]> {
    const url = `${this.requestUrl}api/Payrolls/getCatalogPayrolls?companyPayId=${companyPayId}&payrollTypeId=${payrollTypeId}&profile=${profile}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getEmployeeIds(payrollId: number, bossId: number): Observable<number[]> {
    const url = `${this.requestUrl}api/Payrolls/getEmployeeIds?payrollId=${payrollId}&bossId=${bossId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public updatePayrollLocked(dto: IDtoPayroll): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/updatePayrollLocked`;
    return this.service.putWithId(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public validatePayrolldLock(payrollId: number, profile: string): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/validatePayrollLock?payrollId=${payrollId}&profile=${profile}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public validatePayrollContractByEmployee(requisitionId: number, datehire: Date, employeeId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Payrolls/validatePayrollContractByEmployee?requisitionId=${requisitionId}&datehire=${datehire}&employeeId=${employeeId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  public getPayrollByStructure(date: Date, clientId: number, projectId: number, payrollTypeId: number, codeNomcompanyPay: string): Observable<IResult> {
    const formattedDate = date.toISOString();
    const url = `${this.requestUrl}api/Payrolls/getPayrollByStructure?date=${formattedDate}&clientId=${clientId}&projectId=${projectId}&payrollTypeId=${payrollTypeId}&codeNomcompanyPay=${codeNomcompanyPay}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  public getCatalogRetention(): Observable < IDtoCatalog[] > {
    const url = `${this.requestUrl}api/Retentions/getCatalogRetention`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getLastActivePeriod(companyNum: string, payrollType: string): Observable<IResult> {
    const url = `${this.payrollUrl}api/Periods/getLastActivePeriod?companyNum=${companyNum}&payrollType=${payrollType}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getEmployeesFromPayroll(payrollId: number, bossId: number): Observable<IDtoEmployee[]> {
    const url = `${this.requestUrl}api/Payrolls/getEmployeesFromPayroll?payrollId=${payrollId}&bossId=${bossId}`;
    return this.service.get(url).pipe(map((response: any) => {
        return response;
    }));
}
}
